const $ = require('jquery');

const FULL_SIZE_HERO_CLASS = '.hero--full-page'

$(FULL_SIZE_HERO_CLASS).css('height', $(window).height() - $('header.header').outerHeight(true));

$(window).on('resize', () => {
  $(FULL_SIZE_HERO_CLASS).css('height', $(window).height() - $('header.header').outerHeight(true));
})
